import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

export class BridgeAuthenticationController extends BridgeComponent {
    static component = "authentication"
    static values = {
        authenticated: Boolean,
    }

    connect() {
        super.connect()
        if (this.bridgeElement.enabled) {
            this.send("connect", {authenticated: this.authenticatedValue})
        }
    }
}
